import React from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';

const coloresBoton = {
  'E-BOOK': '#0A6274',
  'PLANTILLA': '#1D6D78',
  'INFOGRAFÍA': '#0A6274',
};

export default function RecursoDestacado({ recurso, estaSuscrito, onDownload }) {
  return (
    <Box sx={{ width: '296px', mx: 'auto' }}>
      {/* Imagen con ícono y overlay */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '263px',
          borderRadius: '20px',
          overflow: 'hidden',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
          '&:hover .overlay': {
            opacity: 0.2,
          },
        }}
      >
        <Box
          component="img"
          src={recurso.imagen}
          alt={recurso.titulo}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '20px',
            display: 'block',
          }}
        />

        <Box
          className="overlay"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#000',
            opacity: 0,
            transition: 'opacity 0.3s ease-in-out',
            borderRadius: '20px',
            zIndex: 1,
          }}
        />

        <IconButton
          sx={{
             position: 'absolute',
                  top: 10,
                  right: 8,
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: 'linear-gradient(90deg, rgba(10, 98, 116, 0.7), rgba(19, 184, 218, 0.6))',
                  border: '1px solid rgba(19, 184, 218, 0.5)',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                  color: '#fff',
                  zIndex: 1,
                  backdropFilter: 'blur(2px)',
                  WebkitBackdropFilter: 'blur(2px)',
                  transition: 'background 0.3s ease',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #0A6274, #0A6274)',
                  },
          }}
          onClick={() => {
            if (estaSuscrito) {
              onDownload();
            } else {
              alert('Suscríbete para descargar este recurso.');
            }
          }}
        >
          <Box
            component="img"
            src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744825924/ebm/download-icon_al5gur.png"
            alt="Descargar"
            sx={{ width: 18, height: 18 }}
          />
        </IconButton>

      </Box>

      {/* Título */}
      <Typography
        sx={{
          mt: 2,
          fontSize: '14px',
          fontWeight: 600,
          fontFamily: 'Poppins, sans-serif',
          color: '#38383D',
          textAlign: 'left',
        }}
      >
        {recurso.titulo}
      </Typography>

      {/* Botón de tipo */}
      <Button
        variant="contained"
        disableElevation
        sx={{
          mt: 1,
          fontSize: '11px',
          fontWeight: 700,
          fontFamily: 'Poppins, sans-serif',
          borderRadius: '30px',
          padding: '4px 16px',
          backgroundColor: coloresBoton[recurso.tipo] || '#D4A76A',
          color: 'white',
          textAlign: 'left',
          display: 'block',
        }}
      >
        {recurso.tipo}
      </Button>

      {recurso.descripcion && (
        <Typography
          sx={{
            mt: 1,
            fontSize: '12px',
            fontWeight: 400,
            fontFamily: 'Poppins, sans-serif',
            color: '#6B6B6B',
            textAlign: 'justify',
            lineHeight: 1.4,
          }}
        >
          {recurso.descripcion}
        </Typography>
      )}
    </Box>
  );
}
